import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_2267_22594)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2267_22594" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "13",
      height: "6",
      fill: "white",
      transform: "translate(6 0.5) rotate(90)"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'downArrowVectorIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 6,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    style: _normalizeStyle(`width: ${__props.width}; height: ${__props.height}`),
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M3.72709 12.7467L5.72709 9.41333C5.78711 9.31212 5.81926 9.19682 5.82029 9.07916C5.82131 8.96149 5.79118 8.84565 5.73295 8.7434C5.67471 8.64115 5.59045 8.55614 5.48872 8.497C5.387 8.43785 5.27143 8.40669 5.15376 8.40667L4.33376 8.40667C4.28956 8.40667 4.24717 8.38911 4.21591 8.35785C4.18465 8.3266 4.16709 8.2842 4.16709 8.24L4.1671 1.5C4.1671 1.23478 4.06174 0.98043 3.8742 0.792893C3.68667 0.605357 3.43231 0.5 3.1671 0.5C2.90188 0.5 2.64753 0.605357 2.45999 0.792893C2.27245 0.98043 2.1671 1.23478 2.1671 1.5L2.1671 8.24C2.1671 8.2842 2.14954 8.3266 2.11828 8.35785C2.08702 8.38911 2.04463 8.40667 2.00043 8.40667L1.1671 8.40667C1.04896 8.40687 0.933009 8.43846 0.831098 8.4982C0.729187 8.55794 0.644979 8.64369 0.587094 8.74667C0.530626 8.8463 0.500779 8.95881 0.500428 9.07333C0.500464 9.19299 0.532702 9.31043 0.593762 9.41333L2.59376 12.7467C2.65279 12.8461 2.73669 12.9286 2.83721 12.9858C2.93773 13.043 3.05142 13.0731 3.16709 13.0731C3.28277 13.0731 3.39646 13.043 3.49698 12.9858C3.5975 12.9286 3.6814 12.8461 3.74043 12.7467L3.72709 12.7467Z",
        fill: __props.color
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4
  ], 12, _hoisted_1))
}
}

})